import React, { useState, useEffect } from 'react'
import Grid from '@material-ui/core/Grid';
import SendOutlined from '@material-ui/icons/SendOutlined';
import NotifyModal from 'components/NotifyModal'
import FormSelectService from './components/FormSelectService'
import SelectOperatorModal from './components/SelectOperatorModal'
import FormRegisterCompany from './components/RegisterCompany'
import { users, operators } from 'api/index'
import { useHistory } from 'react-router-dom'

import { useStoreActions, useStoreState } from 'store/index'

import Swal from 'sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import { useTranslation } from 'hooks/useTranslation'

const isShowSwal = false

const Identify = () => {
	const { t } = useTranslation()
	// const history = useHistory()
	// const { servicePortalToken } = useStoreState(s => s.userModel)
	// const selectedPOA = useStoreState(s => s.poa.selected)

	// const signinSdoc = useStoreActions(a => a.sdocUserModel.signInUser)
	// const { setServicePortalToken, signin: signinQos } = useStoreActions(
	// 	a => a.userModel
	// )
	const history = useHistory()
	const { servicePortalToken, userFromServicePortal } = useStoreState(s => s.userModel)
	const selectedPOA = useStoreState(s => s.poa.selected)
	const POA = useStoreState(s => s.poa.data)
	const actionIdentify = useStoreActions(a => a.userModel.identify)
	const signinSdoc = useStoreActions(a => a.sdocUserModel.signInUser)
	const { setServicePortalToken, signin: signinQos } = useStoreActions(
		a => a.userModel
	)

	const {
		setData: setPOAData,
		setDataDBD,
		setSelected: selectPOA,
	} = useStoreActions(a => a.poa)

	// const { setDataDBD } = useStoreActions(a => a.poa)

	const signinQosWithRegisterCompany = useStoreActions(
		a => a.userModel.signinQosWithRegisterCompany
	)
	// eslint-disable-next-line
	const [loadPoaSuccess, setLoadPoaSuccess] = useState(false)
	// eslint-disable-next-line
	const [selectPOAError, setSelectPOAError] = useState(false)

	const [openNoPOAModal, setOpenNoPOAModal] = useState(false)
	// eslint-disable-next-line
	const [openPOAModal, setOpenPOAModal] = useState(false)
	const [activeRegisterCompany, setActiveRegisterCompany] = useState(false)

	const onSelectService = service => {
		// signinSdoc({ _token: servicePortalToken })
		// 	.then(data => {
		// 		if (data !== null) {
		// 			history.replace('/sdoc')
		// 		}
		// 	})
		// 	.catch(() => {
		// 		alert('error case 1')
		// 	})

		if (POA) {
			setOpenPOAModal(true)
		} else {
			// setOpenNoPOAModal(true)
		}
	}
	const submitRegisterCompany = async payload => {
		await signinQosWithRegisterCompany(payload)
			.then(e => {
				history.replace('/sdoc')
			})
			.catch(e => { })
	}
	useEffect(() => {
		if (isShowSwal) {
			Swal.fire({
				title: t('auth.maintenanceTitle'),
				html: `
				<div style="line-height: 33px !important;">
					<p style="text-align:left;text-indent:4ch;margin-bottom:1rem;">${t('auth.maintenanceBody')}</p>
					<p style="text-align:right;text-indent:4ch;margin-bottom:1rem;">${t('auth.maintenanceOrg')}</p>
				</div>
			 `,
				icon: 'warning',
				width: '700',
				showCancelButton: false,
				confirmButtonText: t('auth.acknowledged'),
				reverseButtons: true,
			});
		}
		// const urlSearchParams = new URLSearchParams(window.location.search)
		// const params = Object.fromEntries(urlSearchParams.entries())

		// setServicePortalToken(params._token)

		// signinSdoc({ _token: params._token })
		// 	.then(data => {
		// 		if (data !== null) {
		// 			history.replace('/sdoc')
		// 		}
		// 	})
		// 	.catch(() => {
		// 		alert('error case 1')
		// 	})
		const urlSearchParams = new URLSearchParams(window.location.search)
		const params = Object.fromEntries(urlSearchParams.entries())
		async function getListPOASDoC(token) {
			const res = await users.getMyPOASDoC(token)
			if (res) {
				setPOAData(res)
				setLoadPoaSuccess(true)
				setOpenPOAModal(true)
			} else {
				setPOAData(null)
				setLoadPoaSuccess(true)
			}
		}

		if (!params._token) {
			// history.replace('/sign-in')
		}
		setServicePortalToken(params._token)

		actionIdentify({ _token: params._token })
			.then(data => { })
			.catch(() => {
				setOpenNoPOAModal(true)
			})

		getListPOASDoC(params._token)

		// eslint-disable-next-line
	}, [])

	useEffect(() => {
		if (selectedPOA !== null && selectedPOA.operator !== null) {
			if (selectedPOA !== 0 && !selectedPOA.isShop) {
				signinSdoc({ _token: servicePortalToken, poa: selectedPOA.juristicNo })
					.then(data => {
						if (data !== null) {
							history.replace('/sdoc')
						}
					})
					.catch(() => {
						Swal.fire({
							text: t('auth.unregisteredCompany'),
							icon: 'error',
						})
					})
			} else if (selectedPOA.isShop) {
				// Handle Shop Selection
				const shopTaxId = selectedPOA.taxId || selectedPOA.TaxId
				const foundPOA = POA && POA.find(p => p.juristicNo == shopTaxId)
				if (foundPOA) {
					signinSdoc({ _token: servicePortalToken, poa: foundPOA.juristicNo })
						.then(data => {
							if (data !== null) {
								history.replace('/sdoc')
							}
						})
						.catch(() => {
							Swal.fire({
								text: t('auth.unregisteredCompany'),
								icon: 'error',
							})
						})
				} else {
					// Optimistic Login: Try signing in even if not in POA list (in case list is stale)
					signinSdoc({ _token: servicePortalToken, poa: shopTaxId })
						.then(data => {
							if (data !== null) {
								history.replace('/sdoc')
							}
						})
						.catch(() => {
							// Login failed, implies not registered or not authorized. Proceed to Registration.
							const shopData = {
								BranchId: selectedPOA.branchId || selectedPOA.BranchId || '00000',
								juristicID: shopTaxId,
								juristicName_TH: selectedPOA.fullnameTH || selectedPOA.FullnameTH || selectedPOA.nameTh || selectedPOA.NameTh,
								AddressInformations: [
									{
										FullAddress: selectedPOA.fullAddress || selectedPOA.FullAddress || selectedPOA.addressNo || selectedPOA.AddressNo,
										Tumbol: selectedPOA.subDistrict || selectedPOA.SubDistrict,
										Ampur: selectedPOA.district || selectedPOA.District,
										Province: selectedPOA.province || selectedPOA.Province,
									}
								]
							}
							setDataDBD(shopData)
							setOpenPOAModal(false)
							setActiveRegisterCompany(true)
						})
				}
			} else {
				signinSdoc({ _token: servicePortalToken, poa: null })
					.then(data => {
						if (data !== null) {
							history.replace('/sdoc')
						}
					})
					.catch(() => {
						Swal.fire({
							text: 'บริษัทนี้ไม่ได้ลงทะเบียนใช้งาน QOS ไว้',
							icon: 'error',
						})
					})
			}
		} else if (selectedPOA !== null && selectedPOA.operator === null) {
			operators
				.getOperatorInfoDBD({ taxno: selectedPOA.juristicNo, pid: userFromServicePortal.UserProfile.NationalID })
				.then(e => {
					if (e.status !== 200) {
						setSelectPOAError(true)
						return false
					} else {
						return e
					}
				})
				.then(e => e.data)
				.then(data => {
					if (data?.data1000101001) {
						const list = data.data1000101001.ResultList || data.data1000101001.resultList
						if (Array.isArray(list) && list.length > 0) {
							const foundCompany = list[0]
							setDataDBD(foundCompany)
							setOpenPOAModal(false)
							setActiveRegisterCompany(true)
						} else {

						}
					} else {
						const blankData = {
							"ResultList": [
								{
									"JuristicType": null,
									"JuristicID": selectedPOA.juristicNo,
									"OldJuristicID": null,
									"RegisterDate": null,
									"JuristicName_TH": null,
									"JuristicName_EN": null,
									"RegisterCapital": null,
									"PaidRegisterCapital": null,
									"NumberOfObjective": null,
									"NumberOfPageOfObjective": null,
									"JuristicStatus": null,
									"StandardID": null,
									"CommitteeInformations": [
									],
									"AuthorizeDescriptions": [
									],
									"StandardObjectives": [
									],
									"AddressInformations": [
										{
											"Sequence": null,
											"AddressName": null,
											"FullAddress": null,
											"Building": null,
											"RoomNo": null,
											"Floor": null,
											"VillageName": null,
											"AddressNo": null,
											"Moo": null,
											"Soi": null,
											"Road": null,
											"Tumbol": null,
											"Ampur": null,
											"Province": null,
											"Phone": null,
											"Email": null
										}
									]
								}
							]
						}
						const foundCompany = blankData.ResultList[0];
						setDataDBD(foundCompany)
						setOpenPOAModal(false)
						setActiveRegisterCompany(true)
					}
				})
				.catch(err => {
					console.error(err)
				})
		}
		// eslint-disable-next-line
	}, [selectedPOA])

	return (
		<Grid className="h-screen flex flex-col items-center justify-center sign-in-container p-3">
			{loadPoaSuccess && !activeRegisterCompany && (
				<FormSelectService onSelectService={onSelectService} />
			)}
			{activeRegisterCompany && (
				<FormRegisterCompany
					onSubmit={submitRegisterCompany}
					goBack={() => {
						setActiveRegisterCompany(false)
					}}
				/>
			)}
			<NotifyModal
				title={t('auth.noPOATitle')}
				content={t('auth.noPOAContent')}
				// content="ขณะนี้ระบบทำการปิดปรับปรุง โปรดลองใหม่อีกครั้งในภายหลัง เวลา 20.00 น."
				header_icon={
					<SendOutlined style={{ fontSize: 20 }} className="mr-1 text-white" />
				}
				open={openNoPOAModal}
				onClose={() => {
					setOpenNoPOAModal(false)
					history.replace('/signin')
				}}
			/>

			<SelectOperatorModal
				title={t('auth.selectTitle')}
				content={t('auth.selectContent')}
				header_icon={
					<SendOutlined style={{ fontSize: 20 }} className="mr-1 text-white" />
				}
				isError={selectPOAError}
				open={openPOAModal}
				token={servicePortalToken}
				onClose={() => {
					selectPOA(null)
					setOpenPOAModal(false)
					setSelectPOAError(false)
				}}
			/>
		</Grid>
	)
}

export default Identify
